import { ChangeDetectionStrategy, Component } from '@angular/core';

import { OrbiAnnouncerService } from '../../services/orbi-announcer.service';

@Component({
  selector: 'patient-ui-orbi-live-region',
  templateUrl: './orbi-live-region.component.html',
  styleUrls: ['./orbi-live-region.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OrbiLiveRegionComponent {
  readonly polite$ = this.announcer.polite$;
  readonly assertive$ = this.announcer.assertive$;

  constructor(private readonly announcer: OrbiAnnouncerService) {}
}
